// Pure helpers for the graph event popup (EventPopUp.jsx). React-free so they
// can be unit-tested with `node --test` (the test sets up the @managers alias
// and transpiles the shared module — see __tests__/registerManagersAlias.js).

// displayPressureUnit lives in sciroot-clients-shared's unitsManager so web and
// mobile render water-column pressure units (cm H₂O / inch H₂O) identically.
const { displayPressureUnit } = require('@managers/unitsManager');

// Formats the pressure subtitle text shown for an irrigation event:
// `value unit (Pressure)`, with a space between the value and unit (matching
// the reported-events subtitle). Shared by the graph popup (buildPressureRow)
// and the reported-events list (NextActionsContainer) so both read identically.
//
// Returns null when there is no pressure reading, so non-pressure irrigation
// events are left unchanged. A pressure of 0 is a valid reading and is shown
// (only null/undefined are treated as "no reading").
const formatPressureSubtitle = (pressure, pressureUnit, pressureLabel) => {
  if (pressure === null || pressure === undefined) {
    return null;
  }
  let unitSuffix = pressureUnit ? ' ' + displayPressureUnit(pressureUnit) : '';
  return pressure + unitSuffix + ' (' + pressureLabel + ')';
};

// Builds the pressure line shown under the irrigation amount in an irrigation
// event popup. The text mirrors the reported-events subtitle in
// NextActionsContainer (`value unit (Pressure)`), and the markup matches the
// popup's first line (irrigation amount) so the two lines look identical.
//
// Returns '' when there is no pressure reading, so non-pressure irrigation
// events render exactly as before.
const buildPressureRow = (pressure, pressureUnit, pressureLabel) => {
  const text = formatPressureSubtitle(pressure, pressureUnit, pressureLabel);
  if (text === null) {
    return '';
  }
  return (
    "<div class='pl-2 mr-1 text-grey71 font-weight-semi-bold align-self-center' style='font-size: 14px;white-space: nowrap'>" +
    text +
    '</div>'
  );
};

module.exports = {
  buildPressureRow,
  formatPressureSubtitle,
  displayPressureUnit,
};
